
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const FindPlus = lazy(() => import('../pages/solutions/find-plus/page'));
const ReadyMix = lazy(() => import('../pages/solutions/ready-mix/page'));

const EarthTransportation = lazy(() => import('../pages/solutions/earth-transportation/page'));
const WasteManagement = lazy(() => import('../pages/solutions/waste-management/page'));
const CementTransport = lazy(() => import('../pages/solutions/cement-transport/page'));
const LaundryManagement = lazy(() => import('../pages/solutions/laundry-management/page'));
const PrivacyPolicy = lazy(() => import('../pages/legal/privacy'));
const TermsAndConditions = lazy(() => import('../pages/legal/terms'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/solutions/find-plus',
    element: <FindPlus />
  },
  {
    path: '/solutions/ready-mix',
    element: <ReadyMix />
  },

  {
    path: '/solutions/earth-transportation',
    element: <EarthTransportation />
  },
  {
    path: '/solutions/waste-management',
    element: <WasteManagement />
  },
  {
    path: '/solutions/cement-transport',
    element: <CementTransport />
  },
  {
    path: '/solutions/laundry-management',
    element: <LaundryManagement />
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />
  },
  {
    path: '/terms',
    element: <TermsAndConditions />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
